<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-return-partners'>{{translations('return_partner.archive_manufacturer_return')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('return_partner.register_manufacturer_return')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('return_partner.applied_date')}}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnPartnerInfo.applied_at) || '----------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.applied_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_applied' class='form-control input-date'>
                      <input type='time' v-model='time_applied' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('applied_at',`${date_applied} ${time_applied}`,'info01')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.shipped_date')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnPartnerInfo.shipped_at) || '----------' }}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.shipped_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_shipped' class='form-control input-date'>
                      <input type='time' v-model='time_shipped' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('shipped_at',`${date_shipped} ${time_shipped}`,'info02')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.approved_date')}}</th>
                <td>
                  <button
                    ref='info09'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info09'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnPartnerInfo.approved_at) || '----------' }}</button>
                  <div id='popover-info09' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.approved_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_approved' class='form-control input-date'>
                      <input type='time' v-model='time_approved' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('approved_at',`${date_approved} ${time_approved}`,'info09')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.offset_date')}}</th>
                <td>
                  <button
                    ref='info10'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info10'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnPartnerInfo.offset_at) || '----------' }}</button>
                  <div id='popover-info10' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.offset_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_offset' class='form-control input-date'>
                      <input type='time' v-model='time_offset' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('offset_at',`${date_offset} ${time_offset}`,'info10')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.organization_number')}}</th>
                <td>
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >{{ returnPartnerInfo.reference_number || '----------'}}</button>
                  <div id='popover-info03' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.organization_number')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input ref='input-info03' type='text' v-model='tempInfo.reference_number' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('reference_number',tempInfo.reference_number,'info03')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.product_origin')}}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ returnPartnerInfo.product_origin_id || '----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.product_origin')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <select
                        class='form-control'
                        v-model="tempInfo.product_origin_id">
                        <option
                          v-for="type in translationProductOrigin"
                          :key="type.id"
                          :value="type.id"
                        >
                          {{ type.name }}
                        </option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('product_origin_id',tempInfo.product_origin_id,'info07')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.affects_inventory')}}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ returnPartnerInfo.affect_inventory_id || '----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.affects_inventory')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <select
                        class='form-control'
                        v-model="tempInfo.affect_inventory_id">
                        <option
                          v-for="type in translationAffectsInventory"
                          :key="type.id"
                          :value="type.id"
                        >
                          {{ type.name }}
                        </option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('affect_inventory_id',tempInfo.affect_inventory_id,'info08')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.manufacturer')}}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ returnPartnerInfo.manufacturers_id || '----------'}}</button>
                  <div id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.manufacturer')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_partners" label="name" value="id" v-model="tempInfo.manufacturers_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('manufacturers_id', tempInfo.manufacturers_id,'info05')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return_partner.remarks')}}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ returnPartnerInfo.memo || '----------' }}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return_partner.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info06')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('return_partner.product_condition')}}</th>
                  <th>{{translations('return_partner.warehouse')}}</th>
                  <th>{{translations('return_partner.operation')}}</th>
                  <th>{{translations('return_partner.verification_results')}}</th>
                  <th>{{translations('return_partner.model_number')}}</th>
                  <th>{{translations('return_partner.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('return_partner.number_item')}}</th>
                  <th class="width-50-px">{{translations('return_partner.unit_price')}}</th>
                  <th class="width-50-px"></th>
                  <th>{{translations('return_partner.original_unit_price')}}</th>
                  <th>{{translations('return_partner.summary')}}</th>
                  <th>{{translations('return_partner.unit_price_total')}}</th>
                  <th>{{translations('return_partner.total_liabilities')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <tr v-for='(detail, i) in returnDetail' :key='i'>
                  <td>
                    <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                  </td>
                  <td>{{ typeProduct(detail.type_product_id) }}</td>
                  <td>{{ detail.warehouse.name }}</td>
                  <td></td>
                  <td>
                    <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info03' + i"
                        data-placement='right'
                    >{{ detail.test_result ? detail.test_result : '-------------' }}</button>
                    <div :ref="'popover-info03' + i" :id="'popover-info03' + i" class='popover popover-default popover-x has-footer'>
                      <div class='arrow'></div>
                      <div class='popover-header popover-title'>
                        <button class='close' data-dismiss='popover-x'>×</button>{{translations('return_partner.verification_results')}}
                      </div>
                      <div class='popover-body popover-content'>
                        <textarea class='form-control' v-model="tempDetail[i].test_result"></textarea>
                      </div>
                      <div class='popover-footer'>
                        <button @click="updateField('test_result', tempDetail[i].test_result, ('info03' + i), detail)" type='submit' class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                      </div>
                    </div>
                    <div class='popover-x-marker' style='display: none;'></div>
                  </td>
                  <td>{{ detail.model }}</td>
                  <td>
                    <select
                        :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onchangeTaxclass"
                    >
                      <option value="1">{{translations('return_partner.taxable_item')}}</option>
                      <option value="2">{{translations('return_partner.not_applicable')}}</option>
                    </select>
                  </td><!-- TAXSTATUS -->
                  <!-- <td class="right" v-if="taxIncluded" colspan="2">{{ toTaxFormat(detail, 'unit_price') }}</td> -->
                  <td class="right">{{ detail.quantity.toLocaleString() }}</td>
                  <td>
                    <div v-if="!taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                      <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" :id="'unit_price' + i" @focus="refresh('unit_price' + i)" @blur="refresh('unit_price' + i)" @input="onChangePrice('unit_price', detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                      <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                    </div>
                    <div v-if="taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                      <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price_inctax" :id="'unit_price_inctax' + i" @focus="refresh('unit_price_inctax' + i)" @blur="refresh('unit_price_inctax' + i)" @input="onChangePrice('unit_price_inctax', detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                      <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price_inctax && detail.unit_price_inctax.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                    </div>
                  </td>
                  <td v-if="Number(detail.taxclass_id) === 1" class="right">
                    ({{ toUnitPriceTaxLabel(detail) }})
                  </td>
                  <td v-else></td>

                  <td class="right">{{ toTaxFormat(detail, 'row_price') }}</td>

                  <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks"/></td>

                  <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                  <td class="right">{{ detail.return_status_id === 1 ? toTaxFormat(detail, 'total_cost') : '' }}</td>
                </tr>
                <tr class='bg-lightgreen'>
                  <td>
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReturnPartnersModal'><i></i></button>
                  </td>
                  <td colspan="11"></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalDebt, grandTotalDebtIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <button @click="addReturnPartner()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewReturnPartnersModal
      :returnDetails='returnDetail'
      :returnWarehouses="master_mywarehouses"
      :partnerId="tempInfo.manufacturers_id"
      :arrivedDate="date_applied"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    />
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import $ from 'jquery'
import { format } from 'date-fns'
import VueElementLoading from 'vue-element-loading'
import NewReturnPartnersModal from '@/components/NewReturnPartnersModal'
import { mapState } from 'vuex'
import { Condition } from '@/constants'
export default {
  name: 'NewReturnPartners',
  props: {},
  components: {
    VueElementLoading,
    NewReturnPartnersModal
  },
  watch: {
    returnDetail: {
      handler (v) {
        this.tempDetail = v
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    }
  },
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      isLoading: false,
      personals: [],
      returnPartnerInfo: {},
      returnDetail: [],
      tempInfo: {},
      tempDetail: [],
      delivery_destinations: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalDebt: 0,
      grandTotalDebtIncTax: 0,
      date_applied: format(new Date(), 'yyyy-MM-dd'),
      date_shipped: format(new Date(), 'yyyy-MM-dd'),
      date_approved: format(new Date(), 'yyyy-MM-dd'),
      date_offset: format(new Date(), 'yyyy-MM-dd'),
      time_applied: format(new Date(), 'HH:mm'),
      time_shipped: format(new Date(), 'HH:mm'),
      time_approved: format(new Date(), 'HH:mm'),
      time_offset: format(new Date(), 'HH:mm')
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    master_partners () {
      if (this.tempInfo.product_origin_id === '0') {
        return this.$store.getters['Master/getPayOverseasTo']
      } else if (this.tempInfo.product_origin_id === '1') {
        return this.$store.getters['Master/getPayTo']
      } else {
        return []
      }
    },
    translationProductOrigin () {
      const productOrigin = [
        { id: '0', name: 'return_partner.overseas' },
        { id: '1', name: 'return_partner.domestic' }
      ]
      return productOrigin.map(product => ({
        ...product,
        name: this.translations(product.name)
      }))
    },
    translationAffectsInventory () {
      const affectsInventory = [
        { id: '0', name: 'return_partner.not_reflect' },
        { id: '1', name: 'return_partner.reflect' }
      ]
      return affectsInventory.map(affectInventory => ({
        ...affectInventory,
        name: this.translations(affectInventory.name)
      }))
    }
  },
  created: async function () {
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkPayOverseasTo')
    this.$store.dispatch('Master/checkPayTo')

    this.setEmptyData()
    await this.listPersonals()

    this.isLoading = true
    Promise.all([
      this.getVatRate(), // VAT
      this.getSequence()
    ]).finally(() => {
      this.isLoading = false
      this.setReturnDate()
      this.popoverButtons()
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.returnDetail[index][target] = this.returnDetail[index][target].toString().replace(/[^0-9.-]/g, '')
    },
    getVatRate () { // VAT
      return this.$http.post(this.$api_url.vat_rate).then(response => {
        const result = response.data
        if (result.status === true) {
          this.vatRate = result.vat_rate
        } else {
          this.$toastr.error(this.translations('return_partner.notice_tax_rate'), this.translations('common.error'))
          this.$refs['defaultCheckTax'].disabled = true
        }
      }).catch(error => {
        console.log('NewReturn:getVatRate:catch(error): ', error)
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        return Promise.resolve()
      })
    },

    async listPersonals () {
      try {
        let cList = await this.$http.post(this.$api_url.return_partner_personal_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewReturnPartners:listPersonals')

        if ($data.success === true) {
          this.personals = $data.data
        } else {
          this.personals = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('NewReturnPartners:listPersonals:catch(error): ', JSON.stringify(error))
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
      }
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0

      this.tempDetail.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPrice += Number(v.total_unit_price)
          if (v.return_status_id === 1) {
            this.grandTotalDebt += Number(v.total_cost)
          }
        } else {
          this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
          if (v.return_status_id === 1) {
            this.grandTotalDebtIncTax += Number(v.total_cost_inctax)
          }
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
        this.grandTotalDebtIncTax = this.$util.getIncludeTax(this.grandTotalDebt, this.taxRate)
      } else {
        this.grandTotalUnitPrice = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTax, this.taxRate)
        this.grandTotalDebt = this.$util.getExcludeTax(this.grandTotalDebtIncTax, this.taxRate)
      }
    },

    openAddDetailModal () {
      if (!this.tempInfo.manufacturers_id) {
        this.$toastr.warning(this.translations('return_partner.warning_choose_billing')) // 仕切り取得のため、必須に
      } else if (!this.returnPartnerInfo.applied_at) {
        this.$toastr.warning(this.translations('return_partner.notice_applied_date'))
      } else {
        this.$refs.openAddDetailModal.click()
      }
    },
    setEmptyData () {
      this.returnPartnerInfo = {}
      this.returnDetail = []
      this.tempInfo = {}
      this.tempDetail = []
      this.warehouses = []
      this.bill_to = []
      this.delivery_destinations = []
    },

    isNewReturn () {
      return this.$route.name === 'new-return'
    },

    setReturnDate () {
      this.returnPartnerInfo.applied_at = format(new Date(), "yyyy-MM-dd'T'HH:mm")
      this.tempInfo.applied_at = format(new Date(), "yyyy-MM-dd'T'HH:mm")
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'estimated_at') {
          this.$refs[ref].innerText = '--------------'
        } else {
          this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'shipped_at' || field === 'approved_at' || field === 'offset_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'requester_id') {
        this.personals.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'applied_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
        if (this.returnDetail.length > 0 && this.returnPartnerInfo.applied_at !== val) {
          this.returnDetail = []
        }
      } else if (field === 'manufacturers_id') {
        val = 0
        this.master_partners.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
        if (this.returnDetail.length > 0 && val !== this.returnPartnerInfo.manufacturers_id) {
          this.returnDetail = []
        }
      } else if (field === 'product_origin_id') {
        val = 0
        if (this.tempInfo.manufacturers_id) {
          this.tempInfo.manufacturers_id = null
        }
        this.returnPartnerInfo.manufacturers_id = null
        this.$refs['info05'].innerText = '----------'
        this.translationProductOrigin.forEach(function (v) {
          if (v.id === value) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'affect_inventory_id') {
        val = 0
        this.translationAffectsInventory.forEach(function (v) {
          if (v.id === value) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.returnPartnerInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.returnDetail.splice(i, 1)
    },

    getSequence () {
      return this.$http.post(this.$api_url.return_partner_sequence).then(response => {
        const result = response.data
        if (result.status === true) {
          this.tempInfo.reference_number = result.sequence
          this.returnPartnerInfo.reference_number = result.sequence
          this.$refs['info03'].innerText = result.sequence
          this.$refs['input-info03'].value = result.sequence
        }
      }).catch(error => {
        console.log('NewReturnPartner:getSequence:catch(error): ', error)
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        return Promise.resolve()
      })
    },

    async addReturnPartner () {
      try {
        if (!this.returnPartnerInfo.applied_at) {
          this.$toastr.warning(this.translations('return_partner.notice_applied_date'))
          return
        }

        if (!this.returnPartnerInfo.approved_at) {
          this.$toastr.warning(this.translations('return_partner.notice_approved_date'))
          return
        }

        if (!this.returnPartnerInfo.manufacturers_id) {
          this.$toastr.warning(this.translations('return_partner.notice_manufacturer'))
          return
        }

        if (!this.returnPartnerInfo.affect_inventory_id) {
          this.$toastr.warning(this.translations('return_partner.notice_affect_inventory'))
          return
        }

        if (this.returnDetail.length < 1) {
          this.$toastr.warning(this.translations('return_partner.notice_enter_details_line'))
          return
        }
        this.returnDetail = this.returnDetail.map(item => {
          const { productList, ...rest } = item
          return rest
        })

        this.isLoading = true
        this.returnPartnerInfo.applied_at = format(new Date(this.returnPartnerInfo.applied_at), "yyyy-MM-dd'T'HH:mm:ss")
        this.returnPartnerInfo.shipped_at = this.returnPartnerInfo.shipped_at ? format(new Date(this.returnPartnerInfo.shipped_at), "yyyy-MM-dd'T'HH:mm:ss") : ''
        this.returnPartnerInfo.approved_at = format(new Date(this.returnPartnerInfo.approved_at), "yyyy-MM-dd'T'HH:mm:ss")
        this.returnPartnerInfo.offset_at = this.returnPartnerInfo.offset_at ? format(new Date(this.returnPartnerInfo.offset_at), "yyyy-MM-dd'T'HH:mm:ss") : ''
        const params = {
          information: this.returnPartnerInfo,
          details: this.returnDetail
        }
        console.log(JSON.stringify(params)) // DEBUG
        const response = await this.$http.post(this.$api_url.return_partner_add, params)
        const result = response.data
        if (result.status === true) {
          this.$toastr.success(this.translations('return_partner.notice_save_success'), this.translations('common.success'))
          this.$router.replace('/single-return-partners?return_partner_id=' + result.id)
        } else {
          this.$toastr.error(result.message, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('NewReturnPartner:addReturnPartner:catch(error): ', error)
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
      }
    },
    onchangeTaxclass () {
      this.returnDetail.forEach((detail, i) => {
        if (typeof detail !== 'undefined') {
          this.returnDetail[i] = this.prepareDetails(detail)
        }
      })
      this.calcGrandTotals()
    },

    toUnitPriceTaxLabel (data) {
      const taxIncluded = data.tax_included || this.taxIncluded
      if (taxIncluded) {
        return Number(data.unit_price).toLocaleString()
      } else {
        return Number(data.unit_price_inctax).toLocaleString()
      }
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    onChangePrice (key, detail) {
      const taxRate = Number(detail.tax_rate || this.taxRate)
      detail[key] = detail[key].replace(/[^0-9.-]/g, '')
      if (key === 'unit_price') {
        detail.unit_price_inctax = this.$util.getIncludeTax(detail[key], taxRate)
      } else if (key === 'unit_price_inctax') {
        detail.unit_price = this.$util.getExcludeTax(detail[key], taxRate)
      }
    },

    typeProduct (type) {
      if (type === Condition.BAD) {
        return this.translations('return_partner.bad')
      } else if (type === Condition.OUTLET) {
        return this.translations('return_partner.outlet')
      } else {
        return this.translations('return_partner.good')
      }
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 140px;
}
</style>
